import Header from "../Header";
import { Toaster } from "react-hot-toast";
import Footer from "../Footer";
import React from "react";
import { Outlet, ScrollRestoration, useLocation } from "react-router-dom";
import { TitleProvider, useTitle } from "../provider/TitleProvider";
import { SubHeaderProvider, useSubHeader } from "../provider/SubHeaderProvider";
import { cn } from "@/lib/utils";
import { LayoutContainerClassProvider, useContainerClass } from "../provider/LayoutContainerClass";

const MainLayout = () => {
  const location = useLocation();
  const TitleDisplay = ({ title, align }: { title: string; align: "left" | "center" }) => {
    return (
      <section className="pt-12 pb-2">
        <div className={`max-w-5xl mx-auto px-4 ${align === "center" ? "text-center" : ""}`}>
          <h1 className="text-3xl font-semibold text-gray-900">{title}</h1>
        </div>
      </section>
    );
  };

  const Body = () => {
    const { title, titleAlign } = useTitle();
    const { subHeader } = useSubHeader();
    const { containerClass } = useContainerClass();

    return (
      <div className="flex flex-col flex-1">
        {title && <TitleDisplay title={title} align={titleAlign} />}
        {subHeader && subHeader}
        <section className={cn(containerClass, { "pt-0": title })}>
          <div className="max-w-[1200px] mx-auto px-4">
            <Outlet />
          </div>
        </section>
      </div>
    );
  };

  return (
    <div className="flex flex-col min-h-screen">
      <ScrollRestoration />
      <Header />
      <div className="flex-1 bg-[#f0f5fb]">
        <SubHeaderProvider key={location.pathname}>
          <TitleProvider key={location.pathname}>
            <LayoutContainerClassProvider>
              <Body />
            </LayoutContainerClassProvider>
          </TitleProvider>
        </SubHeaderProvider>
      </div>
      <Toaster />
      <Footer />
    </div>
  );
};

export default MainLayout;
